import { cnpj } from 'cpf-cnpj-validator';
import yup from 'src/libs/yup';

const optionalCnpjSchema = yup.string().test({
  name: 'cnpj',
  exclusive: false,
  message: '${path} não possui um formato válido',
  test(value) {
    return !value || cnpj.isValid(value);
  },
});

export const VoucherStampStoreSchema = yup.object().shape({
  label: yup.string().required().label('Nome'),
  cnpj: optionalCnpjSchema.label('CNPJ'),
  is_default: yup.boolean().required().label('Carimbo padrão'),
  file: yup.mixed().required().isFile().label('Imagem do carimbo'),
});

export const VoucherStampUpdateSchema = yup.object().shape({
  label: yup.string().required().label('Nome'),
  cnpj: optionalCnpjSchema.label('CNPJ'),
  is_default: yup.boolean().required().label('Carimbo padrão'),
  file: yup.mixed().isFile().label('Imagem do carimbo'),
});
